import { Component, OnInit, inject, input, ChangeDetectionStrategy } from '@angular/core';
import { OpportunityStatusService } from '@http/clients/opportunity-status.service';
import { GenericDropdownMultiselectComponent } from 'ngx-lib';
import { FormEditorBase, createValueAccessorProvider } from '../../base/form-editor-base';

@Component({
    selector: 'app-report-opportunity-status-form-editor',
    templateUrl: './report-opportunity-status-form-editor.component.html',
    styleUrls: ['./report-opportunity-status-form-editor.component.scss'],
    providers: [createValueAccessorProvider(ReportOpportunityStatusFormEditorComponent)],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [GenericDropdownMultiselectComponent]
})
export class ReportOpportunityStatusFormEditorComponent extends FormEditorBase<number[] | null> implements OnInit {
    readonly = input<boolean>(false);
    labelText = input<string>('Opportunity Status');
    placeholderText = input<string>('Select Status');

    private readonly opportunityStatusService = inject(OpportunityStatusService);

    async ngOnInit(): Promise<void> {
        const statuses = await this.opportunityStatusService.getAll();
        this.items.set(statuses);
        this.selectedItems.set(this.mapValueToSelectedItems(this.selectedValue() ?? null));
    }

    protected override async onEntityTextChange(): Promise<void> {
        return;
    }

    protected override mapSelectedItemsToValue(): number[] | null {
        const selected = this.selectedItems() ?? [];
        if (!selected.length) return null;
        return selected.map((item) => Number(item.id));
    }

    protected override mapValueToSelectedItems(value: number[] | null): any[] {
        if (!value?.length) return [];
        const selectedIds = new Set(value.map((id) => Number(id)));
        return (this.items() ?? []).filter((item) => selectedIds.has(Number(item.id)));
    }
}
